import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brokeruser-dashboard',
  templateUrl: './brokeruser-dashboard.component.html',
  styleUrls: ['./brokeruser-dashboard.component.css']
})
export class BrokeruserDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
